/**
 * Guest session token storage.
 *
 * The token (minted after the invisible reCAPTCHA) lets anonymous visitors
 * reach the public AI endpoints. It lives in sessionStorage so it is cleared
 * when the tab closes and never persisted long-term. The apiClient request
 * interceptor reads the same key to attach the `x-guest-token` header.
 */
const GUEST_TOKEN_STORAGE_KEY = 'bquest_guest_session_token';
const GUEST_SID_STORAGE_KEY = 'bquest_guest_session_sid';

export const getGuestSessionToken = (): string | null => {
  try {
    return sessionStorage.getItem(GUEST_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setGuestSessionToken = (token: string, sid?: string): void => {
  try {
    sessionStorage.setItem(GUEST_TOKEN_STORAGE_KEY, token);
    if (sid) {
      sessionStorage.setItem(GUEST_SID_STORAGE_KEY, sid);
    }
  } catch {
    // sessionStorage unavailable (private mode quota) — guest calls will 401.
  }
};

export const clearGuestSessionToken = (): void => {
  try {
    sessionStorage.removeItem(GUEST_TOKEN_STORAGE_KEY);
    sessionStorage.removeItem(GUEST_SID_STORAGE_KEY);
  } catch {
    // no-op
  }
};
